import React, { Component } from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

const OVERLAY_TRIGGER_REF = "overlay-trigger";

class HelpIconButtonWithTooltip extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(evt) {
    if (!evt) {
      return;
    }

    const tagName = evt.target.tagName;
    // If it is a button or link, close the modal.
    if (tagName === "A" || tagName === "BUTTON") {
      this.refs[OVERLAY_TRIGGER_REF].hide();
    }
  }

  render() {
    const tooltip = (
      <Tooltip id="help-icon-tooltip" onClick={this.onClick}>
        {this.props.tooltipContent}
      </Tooltip>
    );

    return (
      <OverlayTrigger
        ref={OVERLAY_TRIGGER_REF}
        trigger="click"
        placement="bottom"
        overlay={tooltip}
        rootClose
      >
        <FontAwesome
          className={
            "question-mark pointer" +
            (this.props.iconSize ? " question-mark-" + this.props.iconSize : "")
          }
          style={{ textDecoration: "none" }}
          name="question-circle"
        />
      </OverlayTrigger>
    );
  }
}

HelpIconButtonWithTooltip.propTypes = {
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  iconSize: PropTypes.oneOf(["xs", "sm"])
};

export default HelpIconButtonWithTooltip;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/icons/HelpIconButtonWithTooltip.js